import { Box, styled } from "@mui/material";
import { brighthiveTheme } from "../../../theme/theme";

export const DropdownHolder = styled(Box)`
  position: absolute;
  right: 3px;
  top: 4px;

  button {
    background: transparent;
    color: ${brighthiveTheme.palette.accent.contrastText};
    box-shadow: none;
    min-width: 20px;
    padding: 5px;
    height: 30px;
    opacity: 0;

    &:hover {
      background: none;
      box-shadow: none;
      color: ${brighthiveTheme.palette.common.black};
    }

    svg {
      font-size: 16px !important;
    }
  }
`;
